import { useState } from "react";
import WalletSelect from "@/features/wallet-select";
import BuyBotActionsV2 from "./buy-bot-actions-v2";
import SellBotActionsV2 from "./sell-bot-actions-v2";
import TurboBotActions from "./turbo-bot-actions";
import IconButton from "@/ui/icon-button";
import { useNavigate } from "react-router";
import { IconComponent } from "@/ui/icon";
import TokenPositionStats from "./token-position-stats";
import PositionProgressBar from "./components/position-progress-bar";
import BuySellBotTokenProvider from "../../providers/buy-sell-token-provider";
import { useWallet } from "@/providers/wallet";
import { useToken } from "../../hooks/use-token";
import { useGetBotPositions } from "@/api/positions/positions-bot";

const TradePanelPositions = () => {
  const token = useToken();
  const { userId, currentWallet } = useWallet();
  const { data: positions } = useGetBotPositions(userId, currentWallet, 1000);

  const tokenPosition = positions?.find(
    (pos) => pos.token_address?.toLowerCase() === token?.address?.toLowerCase(),
  );

  return (
    <>
      <PositionProgressBar tokenPosition={tokenPosition} />
      <TokenPositionStats tokenPosition={tokenPosition} />
    </>
  );
};

const TradePanel = () => {
  const { currentWallet } = useWallet();

  const [mode, setMode] = useState<"buy" | "sell" | "turbo">("buy");

  const navigate = useNavigate();

  const renderContent = () => {
    switch (mode) {
      case "buy":
        return <BuyBotActionsV2 />;
      case "sell":
        return <SellBotActionsV2 />;
      case "turbo":
        return <TurboBotActions />;
      default:
        return <BuyBotActionsV2 />;
    }
  };

  return (
    <BuySellBotTokenProvider>
      <div className="h-full w-full flex flex-col">
        <div className="w-full flex items-center justify-between relative">
          <WalletSelect />
          <IconButton
            name="back"
            variant="circle"
            className="w-[1.375rem] h-[1.375rem]"
            iconClassName="w-[0.625rem] h-[0.625rem]"
            onClick={() => navigate("/screener")}
          />
          <div className="absolute left-1/2 -translate-x-1/2 text-xs font-semibold">
            Trade
          </div>
        </div>
        <div className="flex gap-1 mt-[0.563rem] h-[1.875rem] font-semibold text-xs">
          <button
            className={`flex-1 rounded-[0.313rem] border ${mode === "buy" ? "bg-green2Bg border-green2" : "bg-transparent border-transparent text-grey"} hover:text-white`}
            onClick={() => setMode("buy")}
          >
            Buy
          </button>
          <button
            className={`flex-1 rounded-[0.313rem] border ${mode === "sell" ? "bg-red2Bg border-red2" : "bg-transparent border-transparent text-grey"} hover:text-white`}
            onClick={() => setMode("sell")}
          >
            Sell
          </button>
          <button
            className={`flex-1 flex items-center justify-center group gap-1 rounded-[0.313rem] border ${mode === "turbo" ? "bg-blueBg border-blue" : "bg-transparent border-transparent text-grey"} hover:text-white`}
            onClick={() => setMode("turbo")}
          >
            <IconComponent
              name="turboBlue"
              className={`w-[0.75rem] h-[0.75rem] group-hover:opacity-100 ${mode === "turbo" ? "opacity-100" : "opacity-50"}`}
            />
            Turbo
          </button>
        </div>
        {currentWallet ? <TradePanelPositions /> : null}
        {renderContent()}
      </div>
    </BuySellBotTokenProvider>
  );
};

export default TradePanel;
